<div class="snack-bar-container" [ngClass]="type">
    <div class="snack-bar-content">
        <div class="icon-container">
            <mat-icon *ngIf="type === 'success'">check_circle</mat-icon>
            <mat-icon *ngIf="type === 'error'">error</mat-icon>
            <mat-icon *ngIf="type === 'warning'">warning</mat-icon>
        </div>
        <div class="message-container">
            {{ message }}
        </div>
    </div>
</div>
